import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Avatar } from "./Avatar";
import { Trophy } from "lucide-react";

const RANK = [
  { medal: "🥇", ring: "#E19C00", label: "Most Active" },
  { medal: "🥈", ring: "#9ca3af", label: "2nd Most Active" },
  { medal: "🥉", ring: "#b45309", label: "3rd Most Active" },
];

export function TopSpotters() {
  const [spotters, setSpotters] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // refreshes every time the Prowl mounts
    api.get("/top-spotters").then(({ data }) => setSpotters(data)).catch(() => setSpotters([]));
  }, []);

  if (!spotters || spotters.length === 0) return null;

  return (
    <div className="leopard-post mb-6" data-testid="top-spotters">
      <div className="leopard-post-inner p-4">
      <h3 className="font-display text-xl font-bold text-spotter-maroon flex items-center gap-2 mb-3">
        <Trophy className="w-5 h-5" style={{ color: "#E19C00" }} />The Top Spotters
      </h3>
      <div className="space-y-2">
        {spotters.slice(0, 3).map((u, i) => {
          const r = RANK[i];
          return (
            <button key={u.id} data-testid={`top-spotter-${i + 1}`} onClick={() => navigate(`/profile/${u.id}`)}
              className="w-full flex items-center gap-3 p-2 rounded-xl border-2 border-black bg-spotter-cream hover:bg-white transition-colors text-left">
              <div className="flex items-center gap-1 shrink-0">
                <span className="font-display font-bold text-lg text-spotter-maroon w-4">{i + 1}.</span>
                <span className="text-xl" aria-hidden="true">{r.medal}</span>
              </div>
              <Avatar user={u} size="md" showPresence />
              <div className="flex-1 min-w-0">
                <div className="font-heading font-bold text-sm truncate">{u.name}</div>
                <div className="text-[11px] text-spotter-maroon truncate">{r.label} · {u.activity_score} activity pts</div>
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-[10px] text-spotter-maroon/60 mt-2">Ranked by logins + engagement (comments & reactions). Updates each visit.</p>
      </div>
    </div>
  );
}
